/**
 * Stand-in for the vue-gtm plugin, used when no GTM container is configured
 * (local development, testing). It mirrors the public API of the plugin so
 * components can call `this.$gtm.*` without guarding every call site.
 */
export default function createGtmStub() {
  return {
    id: null,
    options: { enabled: false, debug: false, loadScript: false },
    isInBrowserContext: () => typeof window !== 'undefined',
    enabled: () => false,
    enable: () => {},
    debugEnabled: () => false,
    debug: () => {},
    dataLayer: () => false,
    trackView: () => {},
    trackEvent: () => {},
  };
}
